<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <listar-setores></listar-setores>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

import ListarSetores from '../../components/patio/Setor/ListarSetores.vue'

export default {
  data() {
    return {
      tab: null,
      page: {
        title: 'Setores',
      },
      breadcrumbs: [
        {
          text: 'Estacionamento',
          disabled: false,
          to: '/patio/Estacionamento',
        },
        {
          text: 'Setores',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarSetores
  },
}
</script>